import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { FixedbottomButtonCover } from "../../../common";
import primaryComponents from "../../../primaryComponents";
// import AccountingSection from "./AccountingSection";
import { AdditionalDetailsForm } from "./AdditionalDetailsForm";
import { BasicInfo } from "./BasicInfo";
import { PriceSummary } from "./PriceSummary";
import { ProductSelection } from "./ProductSelection";
import styles from "./styles.module.scss";
import { useBillsForm } from "./useBillsForm";
import { useValidation } from "./useValidation";

export const BillsForm = ({ isEditMode = false, billsDetails = {} }) => {
  const {
    isSubmittingBills,
    billsForm,
    pODetails,
    isLoadingInvoiceFile,
    setBillsForm,
    createOrUpdateBills,
    handleUploadInvoice,
    // isLoadingBankAccountsList,
    // bankAccount,
    // bankDetails,
    // setBankDetails,
  } = useBillsForm({ isEditMode, billsDetails });
  const { handleSubmit, ...validationParams } = useValidation({ ...billsForm });

  return (
    <form
      className={`${globalStyles.pageColumnGaps} ${styles.purchaseOrderForm}`}
      onSubmit={handleSubmit(() => createOrUpdateBills("IN_REVIEW"))}
    >
      <div className={styles.formTop}>
        <BasicInfo
          {...validationParams}
          isEditMode={isEditMode}
          billsForm={billsForm}
          pODetails={pODetails}
          setBillsForm={setBillsForm}
        />
        <ProductSelection
          {...validationParams}
          pODetails={pODetails}
          billsForm={billsForm}
          setBillsForm={setBillsForm}
        />
      </div>

      <PriceSummary
        {...validationParams}
        pODetails={pODetails}
        billsForm={billsForm}
        setBillsForm={setBillsForm}
      />

      {/* <AccountingSection
        {...validationParams}
        billsForm={billsForm}
        isLoadingBankAccountsList={isLoadingBankAccountsList}
        bankAccount={bankAccount}
        pODetails={pODetails}
        setBillsForm={setBillsForm}
        bankDetails={bankDetails}
        setBankDetails={setBankDetails}
      /> */}

      <AdditionalDetailsForm
        {...validationParams}
        billsForm={billsForm}
        setBillsForm={setBillsForm}
        handleUploadInvoice={handleUploadInvoice}
      />

      <FixedbottomButtonCover>
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          style={{ width: "200px" }}
          type="button"
          isDisabled={isSubmittingBills || isLoadingInvoiceFile}
          isLoading={isSubmittingBills}
          loadingText={"Saving as draft..."}
          onClick={handleSubmit(() => createOrUpdateBills("DRAFT"))}
        >
          Save As Draft
        </primaryComponents.Button>

        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          style={{ width: "200px" }}
          type="submit"
          isDisabled={isSubmittingBills || isLoadingInvoiceFile}
          isLoading={isSubmittingBills}
          loadingText={isEditMode ? "Updating Bill..." : "Creating Bill..."}
        >
          {isEditMode ? "Update Bill" : "Create Bill"}
        </primaryComponents.Button>
      </FixedbottomButtonCover>
    </form>
  );
};
